import React from "react";
import InstanceContactRow from "./InstanceContactRow";
import InstanceContactTable from "./InstanceContactTable";

export default function InstanceAdminDataTable (
  email?: string,
  username?: string
) {
  return (
    <InstanceContactTable
      title="Administrator"
      headers={
        InstanceContactRow({
          rowEmail: "Email",
          rowFirst: "Username",
          rowLast: ""
        }, true)
      }
      tableData={
        InstanceContactRow({
          rowEmail: email || "-",
          rowFirst: username || "-",
          rowLast: ""
        })
      }
    />
  );
}